import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NotificationBaseComponent } from './notification-base/notification-base.component';

@Component({
	standalone: true,
	imports: [RouterModule, NotificationBaseComponent],
	selector: 'lb-notification-enrollment-assigned',
	template: `<lb-notification-base [notification]="notification()">
		<div activity-message>paused their lessons</div>
	</lb-notification-base>`,
	styleUrls: ['./notification-base-shared.component.scss']
})
export class NotificationEnrollmentPausedComponent extends NotificationBaseComponent {}
